import React from 'react';
import PropTypes from 'prop-types';

import Collapse from '../Collapse/Collapse';
import YourOrderItem from './YourOrderItem/YourOrderItem';

const YourOrder = ({ cartVariants, updateQuantity, title }) => (
  <Collapse title={title}>
    <ul>
      {cartVariants.map((item) => {
        const { id, salePrice, price, cadence } = item;
        return (
          <YourOrderItem
            key={id}
            {...item}
            price={salePrice || price}
            updateQuantity={updateQuantity}
            cadence={cadence}
          />
        );
      })}
    </ul>
  </Collapse>
);

YourOrder.propTypes = {
  cartVariants: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      salePrice: PropTypes.string,
      price: PropTypes.string,
      cadence: PropTypes.string,
    })
  ).isRequired,
  updateQuantity: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default YourOrder;
